import React from 'react';
// import '../../../../node_modules/react-vis/dist/style.css';
import 'rc-time-picker/assets/index.css';
import "react-datepicker/dist/react-datepicker.css";

import 'styles/header.css';
import 'styles/footer.css';
import 'styles/about_us.css';
import 'styles/tos.css';
import 'styles/privacy_policy.css';
import 'styles/review.css';
import 'styles/review_email_confirmation.css';
import 'styles/account.css';
import 'styles/login.css';
import 'styles/password_reset.css';
import 'styles/guide_detail.css';
import 'styles/guides.css';
import 'styles/permit_stats.css';
import 'styles/ads_landing.css';
import 'styles/default.css';
import 'styles/agent_favorite_vendor_list.css';
import 'styles/agent_contacts.css';
import 'styles/agent_index.css';
import 'styles/contact_index.css';
import 'styles/agent_landing.css';
import 'styles/vendor_detail.css';
import 'styles/vendor_booking.css';
import 'styles/manage_vendor_booking.css';
import 'styles/vendor_quote.css';
import 'styles/vendor_review.css';
import 'styles/property_inspector.css';
import 'styles/agent_friends.css';
import 'styles/agent_friends_search.css';
import 'styles/vendor_search.css';
import 'styles/vendor_discover.css';
import 'styles/sign_up.css';
import 'styles/contact_vendor_list.css';
import 'styles/vendor_component.css';
import 'styles/vendor_plans.css';
import 'styles/vendor_index.css';
import 'styles/vendor_account.css';
import 'styles/ev_quote.css';
import 'styles/ev_project_view.css';
import 'styles/project_form.css';
import 'styles/planning_code_list.css';
import 'styles/planning_code_search.css';
import 'styles/sf_planning_search.css';
import 'styles/sf_planning_detail.css';
import 'styles/sf_planning_insights.css';
import 'styles/code_landing.css';
import 'styles/code_labels.css';


const Desktop = () => (<React.Fragment></React.Fragment>);

export default Desktop;